import type { GridApi, GridReadyEvent } from 'ag-grid-community';
import { useCallback, useState } from 'react';

export function useAgGridApiState<T>() {
  const [gridApi, setGridApi] = useState<GridApi<T>>();

  const setAgGridApiState = useCallback((event: GridReadyEvent<T>) => {
    setGridApi(event.api);
    event.api.getFilterModel();
  }, []);
  return [gridApi, setAgGridApiState] as const;
}
